<style lang="less">
@import "../../stylesheet/variable.less";
.radio-view {
  list-style: none;
  padding: 0;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;
  z-index: 1000;
  .mask {
    background: rgba(0, 0, 0, 0.5);
    height: 100vh;
    width: 100%;
  }
  .title {
    text-align: center;
    height: 51px;
    line-height: 51px;
    position: relative;
    display: flex;
    padding: 0 15px;
    &::after {
      .setBottomLine()
    }
    .cancel-btn {
      flex: 1;
      text-align: left;
    }
    .confirm-btn {
      flex: 1;
      text-align: right;
    }
  }
  .container {
    height: 342px;
    overflow-y: auto;
    .item {
      position: relative;
      padding: 0 15px;
      height: 48px;
      line-height: 48px;
      color: #797D82;
      font-size: 14px;
      margin: 0;
      &::after {
        .setBottomLine();
      }
      &:active {
        background: #EFEFEF;
      }
      img {
        width: 32px;
        vertical-align: middle;
      }
    }
    .item-value-left,
    .item-label-right {
      position: relative;
      left: 0;
    }
    .item-value-right,
    .item-label-left {
      position: absolute;
      right: 10px;
    }
  }

  .comfirm-btn {
    width: 100%;
    text-align: center;
    height: 49px;
    line-height: 49px;
    background: @orange;
    color: #fff;
  }
}

.radio-enter,
.radio-leave-to {
  transform: translate3d(0, 100%, 0);
  opacity: 0;
}
.radio-enter-active,
.radio-leave-active {
  transition: all 0.3s ease;
}
</style>

<template>
    <ul class="radio-view">
        <div class="mask" v-show="toggle" @click="toggleRadio"></div>
        <transition name="radio">
            <div v-show="toggle" style="background: #fff">
                <div style="marginBottom: '15px'">
                    <div class="title">
                      <span class="cancel-btn" @click="selectItem()">取消</span>
                      <span>{{title}}</span>
                      <span class="confirm-btn" @click="toggleRadio">确定</span>
                    </div>
                    <div class="container">
                      <li class="item" v-for="(item, i) in list" :key="item.value" @click="selectItem(item)">
                        <span :class="`item-label-${align}`">{{item.label}}</span>
                        <!-- <span :class="`item-value-${align}`" v-if="type == 'radio'">
                            <icon size="16" color="rgb(255,95,22)" v-show="item.value == activeId">gouwuche_xuanzhong</icon>
                            <icon size="16" color="#797D82" v-show="item.value !== activeId">gouwuche_weixuanzhong</icon>
                        </span> -->
                        <span :class="`item-value-${align}`">
                          <img :src="iconYes" v-show="item.value == activeId">
                        </span>
                      </li>
                    </div>
                </div>
                <!-- <div class="comfirm-btn" :style="[colorObject]" @click="toggleRadio">确认</div>                         -->
            </div>
        </transition>
    </ul>

</template>
<script>
import _ from "underscore";
import icon from "./icon.vue";
export default {
  props: {
    title: String,
    type: {
      type: String,
      default: 'normal'
    },
    activeId: {
      type: [String, Number],
      default: ""
    },
    list: {
      type: Array
    },
    align: {
      type: String,
      default: "left"
    },
    backgroudColor: String,
    color: String,
    toggle: {
      default: false
    }
  },
  components: {
    icon
  },
  data() {
    return {
      iconYes: require('../../image/refund/iconYes@2x.png'),
    }
  },
  computed: {
    colorObject() {
      return { backgroudColor: this.backgroudColor, color: this.color };
    }
  },
  methods: {
    selectItem(item = {}) {
      this.$emit("select-item", item);
      if(_.isEmpty(item)) {
        this.toggleRadio()
      }
    },
    toggleRadio(item) {
      this.$emit("toggle-radio", item);
    }
  }
};
</script>
